export const ACTION_REQUEST = 'FETCH_ACADEMYCONFIG_REQUEST';
export const ACTION_SUCCESS = 'FETCH_ACADEMYCONFIG_SUCCESS';
export const ACTION_ERROR = 'FETCH_ACADEMYCONFIG_ERROR';
